module.exports = __webpack_public_path__ + "static/media/axon_sprite_2x.29f3f491.png";